export default "__VITE_ASSET__kqtYnLX6__"